import { useEffect } from 'react'
import { useOutletContext } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { useBulkActions } from 'modules/expenses/components/expenses/Detail/hooks/useBulkActions'
import { RouteContextParams } from 'modules/expenses/lib/RouteContextParams'
import { isMyExpensesSection } from 'modules/expenses/lib/common'
import { Expensable } from 'modules/expenses/types/Expensable'

interface SetToPaidExpensableButtonProps {
  expensable: Expensable
  canSetToPaid: boolean
  canReimburseThroughPayroll: boolean
  onLoadingChange?: (loading: boolean) => void
  disabled?: boolean
}

const ToggleExpensablePaidStatusButton = ({
  expensable,
  canSetToPaid,
  canReimburseThroughPayroll,
  onLoadingChange,
  disabled,
}: SetToPaidExpensableButtonProps) => {
  const { section } = useOutletContext<RouteContextParams>()
  const { setToPaid, revertPaid, submitting } = useBulkActions()

  const hasUnkownReimbursementMethod =
    expensable.reimbursementMethod == 'unknown' ||
    expensable.reimbursementMethod == undefined ||
    expensable.reimbursementMethod == null

  useEffect(() => {
    onLoadingChange?.(submitting)
  }, [submitting, onLoadingChange])

  const showSetToPaidButton =
    canSetToPaid && expensable.status === 'approved' && !isMyExpensesSection(section)

  const showRevertSetToPaidButton =
    canSetToPaid &&
    hasUnkownReimbursementMethod &&
    expensable.status === 'paid' &&
    !isMyExpensesSection(section)

  // TODO: Update type of set to paid if can reimburse through payroll

  if (showSetToPaidButton) {
    return (
      <Button
        type={canReimburseThroughPayroll ? 'secondary' : 'primary'}
        disabled={submitting}
        onClick={setToPaid}
      >
        {i18n.t('expenses_v2.buttons.set_as_paid')}
      </Button>
    )
  }

  if (showRevertSetToPaidButton) {
    return (
      <Button
        type="primary"
        disabled={submitting || disabled}
        onClick={revertPaid}
        loading={submitting}
        iconName={submitting ? 'upload' : undefined}
      >
        {i18n.t('expenses_v2.buttons.revert_paid')}
      </Button>
    )
  }
}

export default ToggleExpensablePaidStatusButton
